// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdv-200 {
  background-color: #2E7D32;
  color: white;
}

.cdv-201 {
  background-color: #0EA501;
  color: white;
}

.cdv-202 {
  background-color: #7CB342;
  color: white;
}

.cdv-203 {
  background-color: #1976D2;
  color: white;
}

.cdv-204 {
  background-color: #FFA500;
  color: white;
}

.cdv-205 {
  background-color: #1B5E20;
  color: white;
}

.cdv-206 {
  background-color: #FFB300;
  color: white;
}

.cdv-207 {
  background-color: #C2185B;
  color: white;
}

.cdv-208 {
  background-color: #6A1B9A;
  color: white;
}

.cdv-209 {
  background-color: #004D40;
  color: white;
}

.cdv-210 {
  background-color: #D32F2F;
  color: white;
}

.cdv-211 {
  background-color: #3949AB;
  color: white;
}

.cdv-212 {
  background-color: #00897B;
  color: white;
}

.cdv-213 {
  background-color: #263238;
  color: white;
}

.password-success-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

.success-card {
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 3rem 2.5rem;
  text-align: center;
  max-width: 500px;
  width: 90%;
  position: relative;
  z-index: 10;
  animation: slideIn 0.8s ease-out;
}
@media (max-width: 768px) {
  .success-card {
    padding: 2rem 1.5rem;
    margin: 1rem;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.logo-container {
  margin-bottom: 2rem;
}
.logo-container .logo {
  height: 60px;
  width: auto;
  opacity: 0.9;
}

.success-icon-container {
  margin-bottom: 2rem;
}
.success-icon-container .success-icon {
  display: inline-block;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #4CAF50, #45a049);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  animation: bounceIn 1s ease-out 0.3s both;
  box-shadow: 0 10px 25px rgba(76, 175, 80, 0.3);
}
.success-icon-container .success-icon i {
  font-size: 2.5rem;
  color: white;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.success-content {
  margin-bottom: 2.5rem;
}
.success-content .success-title {
  color: #2c3e50;
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
  animation: fadeInUp 0.8s ease-out 0.5s both;
}
.success-content .success-message {
  color: #5a6c7d;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 0;
  animation: fadeInUp 0.8s ease-out 0.7s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.action-container {
  margin-bottom: 2rem;
}
.action-container .btn-login {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  color: white;
  padding: 12px 30px;
  font-size: 1.1rem;
  font-weight: 500;
  border-radius: 50px;
  transition: all 0.3s ease;
  animation: fadeInUp 0.8s ease-out 0.9s both;
  min-width: 180px;
}
.action-container .btn-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
  background: linear-gradient(135deg, #5a6fd8, #6a42a0);
}
.action-container .btn-login:active {
  transform: translateY(0);
}
.action-container .btn-login i {
  margin-right: 8px;
}

.auto-redirect .redirect-text {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin-bottom: 0;
  animation: fadeInUp 0.8s ease-out 1.1s both;
}
.auto-redirect .redirect-text i {
  margin-right: 8px;
  color: #95a5a6;
}

.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}
.background-decoration .circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}
.background-decoration .circle.circle-1 {
  width: 200px;
  height: 200px;
  top: -100px;
  left: -100px;
  animation-delay: 0s;
}
.background-decoration .circle.circle-2 {
  width: 150px;
  height: 150px;
  top: 50%;
  right: -75px;
  animation-delay: 2s;
}
.background-decoration .circle.circle-3 {
  width: 100px;
  height: 100px;
  bottom: -50px;
  left: 30%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}
@media (max-width: 576px) {
  .success-card .success-title {
    font-size: 1.5rem;
  }
  .success-card .success-message {
    font-size: 0.9rem;
  }
  .success-card .btn-login {
    padding: 10px 25px;
    font-size: 1rem;
    min-width: 160px;
  }
  .success-icon-container .success-icon {
    width: 70px;
    height: 70px;
  }
  .success-icon-container .success-icon i {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_variables.scss","webpack://./src/app/components/change-password/password-changed-success/password-changed-success.component.scss"],"names":[],"mappings":"AA0BA;EAAW,yBAAA;EAA2B,YAAA;ACvBtC;;ADwBA;EAAW,yBAAA;EAA2B,YAAA;ACnBtC;;ADoBA;EAAW,yBAAA;EAA2B,YAAA;ACftC;;ADgBA;EAAW,yBAAA;EAA2B,YAAA;ACXtC;;ADYA;EAAW,yBAAA;EAA2B,YAAA;ACPtC;;ADQA;EAAW,yBAAA;EAA2B,YAAA;ACHtC;;ADIA;EAAW,yBAAA;EAA2B,YAAA;ACCtC;;ADAA;EAAW,yBAAA;EAA2B,YAAA;ACKtC;;ADJA;EAAW,yBAAA;EAA2B,YAAA;ACStC;;ADRA;EAAW,yBAAA;EAA2B,YAAA;ACatC;;ADZA;EAAW,yBAAA;EAA2B,YAAA;ACiBtC;;ADhBA;EAAW,yBAAA;EAA2B,YAAA;ACqBtC;;ADpBA;EAAW,yBAAA;EAA2B,YAAA;ACyBtC;;ADxBA;EAAW,yBAAA;EAA2B,YAAA;AC6BtC;;AAlEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,kBAAA;EACA,gBAAA;AAqEF;;AAlEA;EACE,qCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,mBAAA;EACA,0CAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AAqEF;AAnEE;EAbF;IAcI,oBAAA;IACA,YAAA;EAsEF;AACF;;AAnEA;EACE;IACE,UAAA;IACA,2BAAA;EAsEF;EApEA;IACE,UAAA;IACA,wBAAA;EAsEF;AACF;AAnEA;EACE,mBAAA;AAqEF;AAnEE;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAqEJ;;AAjEA;EACE,mBAAA;AAoEF;AAlEE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yCAAA;EACA,8CAAA;AAoEJ;AAlEI;EACE,iBAAA;EACA,YAAA;AAoEN;;AA/DA;EACE;IACE,UAAA;IACA,qBAAA;EAkEF;EAhEA;IACE,UAAA;IACA,sBAAA;EAkEF;EAhEA;IACE,qBAAA;EAkEF;EAhEA;IACE,UAAA;IACA,mBAAA;EAkEF;AACF;AA/DA;EACE,qBAAA;AAiEF;AA/DE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;AAiEJ;AA9DE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CAAA;AAgEJ;;AA5DA;EACE;IACE,UAAA;IACA,2BAAA;EA+DF;EA7DA;IACE,UAAA;IACA,wBAAA;EA+DF;AACF;AA5DA;EACE,mBAAA;AA8DF;AA5DE;EACE,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,gBAAA;AA8DJ;AA5DI;EACE,2BAAA;EACA,gDAAA;EACA,qDAAA;AA8DN;AA3DI;EACE,wBAAA;AA6DN;AA1DI;EACE,iBAAA;AA4DN;;AAtDE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,2CAAA;AAyDJ;AAvDI;EACE,iBAAA;EACA,cAAA;AAyDN;;AAnDA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAsDF;AApDE;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,wCAAA;AAsDJ;AApDI;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAsDN;AAnDI;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;AAqDN;AAlDI;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAoDN;;AA/CA;EACE;IACE,0BAAA;EAkDF;EAhDA;IACE,4BAAA;EAkDF;AACF;AA9CA;EAEI;IACE,iBAAA;EA+CJ;EA5CE;IACE,iBAAA;EA8CJ;EA3CE;IACE,kBAAA;IACA,eAAA;IACA,gBAAA;EA6CJ;EAzCA;IACE,WAAA;IACA,YAAA;EA2CF;EAzCE;IACE,eAAA;EA2CJ;AACF","sourcesContent":["// Variabile che è possibile richiamare dagli altri file scss\r\n$mat-primary-color: #35364A;\r\n\r\n$mat-secondary-color: #35364A;\r\n\r\n$navbar-text-selected: #00857E;\r\n\r\n$navbar-gray-text: #555667;\r\n\r\n$navbar-white-text: #FFFF;\r\n\r\n$error-color: #B50600;\r\n$warning-color: #C65015;\r\n$success-color: #056E4B;\r\n\r\n\r\n// Larghezza della sidebar\r\n$navbar-brand-width: 300px !default;\r\n$sidebar-width: 300px !default;\r\n\r\n// Logica usata\r\n//  Verde → esito positivo\r\n//  Blu → stato informativo / di sistema\r\n//  Arancio / Giallo → attenzione / transizione\r\n//  Rosso / Nero → rifiuti\r\n\r\n.cdv-200 { background-color: #2E7D32; color: white; } \r\n.cdv-201 { background-color: #0EA501; color: white; } \r\n.cdv-202 { background-color: #7CB342; color: white; } \r\n.cdv-203 { background-color: #1976D2; color: white; } \r\n.cdv-204 { background-color: #FFA500; color: white; } \r\n.cdv-205 { background-color: #1B5E20; color: white; } \r\n.cdv-206 { background-color: #FFB300; color: white; } \r\n.cdv-207 { background-color: #C2185B; color: white; } \r\n.cdv-208 { background-color: #6A1B9A; color: white; } \r\n.cdv-209 { background-color: #004D40; color: white; } \r\n.cdv-210 { background-color: #D32F2F; color: white; } \r\n.cdv-211 { background-color: #3949AB; color: white; } \r\n.cdv-212 { background-color: #00897B; color: white; } \r\n.cdv-213 { background-color: #263238; color: white; } ","@import '../../../../scss/_variables';\r\n\r\n.password-success-container {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.success-card {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  backdrop-filter: blur(10px);\r\n  border-radius: 20px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\r\n  padding: 3rem 2.5rem;\r\n  text-align: center;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  position: relative;\r\n  z-index: 10;\r\n  animation: slideIn 0.8s ease-out;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 2rem 1.5rem;\r\n    margin: 1rem;\r\n  }\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.logo-container {\r\n  margin-bottom: 2rem;\r\n\r\n  .logo {\r\n    height: 60px;\r\n    width: auto;\r\n    opacity: 0.9;\r\n  }\r\n}\r\n\r\n.success-icon-container {\r\n  margin-bottom: 2rem;\r\n\r\n  .success-icon {\r\n    display: inline-block;\r\n    width: 80px;\r\n    height: 80px;\r\n    background: linear-gradient(135deg, #4CAF50, #45a049);\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 0 auto;\r\n    animation: bounceIn 1s ease-out 0.3s both;\r\n    box-shadow: 0 10px 25px rgba(76, 175, 80, 0.3);\r\n\r\n    i {\r\n      font-size: 2.5rem;\r\n      color: white;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes bounceIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.3);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    transform: scale(1.05);\r\n  }\r\n  70% {\r\n    transform: scale(0.9);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.success-content {\r\n  margin-bottom: 2.5rem;\r\n\r\n  .success-title {\r\n    color: #2c3e50;\r\n    font-size: 1.8rem;\r\n    font-weight: 600;\r\n    margin-bottom: 1rem;\r\n    animation: fadeInUp 0.8s ease-out 0.5s both;\r\n  }\r\n\r\n  .success-message {\r\n    color: #5a6c7d;\r\n    font-size: 1rem;\r\n    line-height: 1.6;\r\n    margin-bottom: 0;\r\n    animation: fadeInUp 0.8s ease-out 0.7s both;\r\n  }\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.action-container {\r\n  margin-bottom: 2rem;\r\n\r\n  .btn-login {\r\n    background: linear-gradient(135deg, #667eea, #764ba2);\r\n    border: none;\r\n    color: white;\r\n    padding: 12px 30px;\r\n    font-size: 1.1rem;\r\n    font-weight: 500;\r\n    border-radius: 50px;\r\n    transition: all 0.3s ease;\r\n    animation: fadeInUp 0.8s ease-out 0.9s both;\r\n    min-width: 180px;\r\n\r\n    &:hover {\r\n      transform: translateY(-2px);\r\n      box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);\r\n      background: linear-gradient(135deg, #5a6fd8, #6a42a0);\r\n    }\r\n\r\n    &:active {\r\n      transform: translateY(0);\r\n    }\r\n\r\n    i {\r\n      margin-right: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.auto-redirect {\r\n  .redirect-text {\r\n    color: #7f8c8d;\r\n    font-size: 0.9rem;\r\n    margin-bottom: 0;\r\n    animation: fadeInUp 0.8s ease-out 1.1s both;\r\n\r\n    i {\r\n      margin-right: 8px;\r\n      color: #95a5a6;\r\n    }\r\n  }\r\n}\r\n\r\n// Background decorativo\r\n.background-decoration {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  z-index: 1;\r\n\r\n  .circle {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    animation: float 6s ease-in-out infinite;\r\n\r\n    &.circle-1 {\r\n      width: 200px;\r\n      height: 200px;\r\n      top: -100px;\r\n      left: -100px;\r\n      animation-delay: 0s;\r\n    }\r\n\r\n    &.circle-2 {\r\n      width: 150px;\r\n      height: 150px;\r\n      top: 50%;\r\n      right: -75px;\r\n      animation-delay: 2s;\r\n    }\r\n\r\n    &.circle-3 {\r\n      width: 100px;\r\n      height: 100px;\r\n      bottom: -50px;\r\n      left: 30%;\r\n      animation-delay: 4s;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes float {\r\n  0%, 100% {\r\n    transform: translateY(0px);\r\n  }\r\n  50% {\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n\r\n// Responsive\r\n@media (max-width: 576px) {\r\n  .success-card {\r\n    .success-title {\r\n      font-size: 1.5rem;\r\n    }\r\n    \r\n    .success-message {\r\n      font-size: 0.9rem;\r\n    }\r\n\r\n    .btn-login {\r\n      padding: 10px 25px;\r\n      font-size: 1rem;\r\n      min-width: 160px;\r\n    }\r\n  }\r\n\r\n  .success-icon-container .success-icon {\r\n    width: 70px;\r\n    height: 70px;\r\n    \r\n    i {\r\n      font-size: 2rem;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
